var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 150,
    viewBox: "0 0 149 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5 0.47168C115.645 0.47168 149 33.8265 149 74.9717C149 116.117 115.645 149.472 74.5 149.472C33.3548 149.472 0 116.117 0 74.9717C0 33.8265 33.3548 0.47168 74.5 0.47168ZM70.7749 141.917V115.406C57.2969 101.928 43.8189 88.4498 30.341 74.9717C42.1267 63.1859 53.9125 51.4003 65.6982 39.6146H30.341V102.909H22.891C22.891 79.3288 22.891 55.7484 22.891 32.168C13.2489 43.7806 7.44998 58.6984 7.44998 74.9717C7.44998 110.752 35.4773 139.984 70.7749 141.917ZM40.877 74.9717L70.7749 104.87V45.0738L40.877 74.9717ZM111.745 52.6217C124.089 52.6217 134.095 62.6282 134.095 74.9717C134.095 87.3152 124.089 97.3217 111.745 97.3217C99.4017 97.3217 89.3952 87.3152 89.3952 74.9717C89.3952 62.6282 99.4017 52.6217 111.745 52.6217ZM111.745 45.1718C128.203 45.1718 141.545 58.5136 141.545 74.9717C141.545 91.4299 128.203 104.772 111.745 104.772C96.5487 104.772 84.0098 93.3967 82.1766 78.6967H78.2249V141.917C113.523 139.984 141.55 110.752 141.55 74.9717C141.55 47.7532 125.331 24.3234 102.031 13.8175L78.2249 37.6238V71.2467H82.1766C84.0098 56.5468 96.5487 45.1718 111.745 45.1718ZM22.8938 32.1646H73.1482L94.3908 10.9221C88.1059 8.9725 81.4258 7.92176 74.5 7.92176C53.7441 7.92176 35.1927 17.3542 22.8938 32.1646Z",
    fill: "#0F205E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHelp);
export default __webpack_public_path__ + "static/media/logo__help.ab24d06033074e5009c953dd538c53d2.svg";
export { ForwardRef as ReactComponent };